var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _g2, _path33, _g3, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 791,
    height: 468,
    viewBox: "0 0 791 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5105 207.605C46.5105 207.605 37.0538 206.914 37.9258 228.138C38.7979 249.362 41.0064 260.665 41.0064 260.665C41.0064 260.665 40.7232 265.365 37.0878 264.447C33.4523 263.53 26.5777 258.943 23.2027 262.363C19.8278 265.784 20.9377 271.356 25.5924 277.777C30.2472 284.199 39.8738 298.616 40.7685 299.919C41.6632 301.221 41.9577 303.611 39.3755 303.384C36.7933 303.158 19.3634 297.235 17.053 305.649C14.7426 314.064 30.6436 329.818 32.365 331.573C34.0865 333.329 34.1545 334.439 33.4976 335.492C32.8407 336.545 27.1327 334.02 22.1042 332.536C17.0757 331.052 10.9939 330.271 10.0652 335.209C9.13652 340.147 16.0904 354.813 42.3654 370.137L54.982 376.433L66.9304 368.811C91.5179 350.94 97.0334 335.73 95.6177 330.871C94.2021 326.012 88.2222 327.473 83.3636 329.41C78.505 331.347 73.1141 334.484 72.3213 333.499C71.5285 332.513 71.5058 331.403 73.0348 329.478C74.5637 327.553 88.8111 310.315 85.674 302.15C82.5368 293.984 65.7752 301.606 63.2269 302.093C60.6787 302.58 60.7806 300.156 61.5055 298.797C62.2303 297.438 70.4299 282.081 74.4278 275.24C78.4257 268.4 79.1165 262.85 75.2659 259.668C71.4152 256.486 65.1976 261.842 61.6753 263.122C58.1531 264.402 57.3943 259.725 57.3943 259.725C57.3943 259.725 58.4136 248.263 57.1565 227.062C55.8994 205.861 46.3293 207.571 46.3293 207.571",
    fill: "#37474F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2586 226.609C47.2586 226.609 47.2586 226.756 47.2586 227.051C47.2586 227.345 47.3152 227.798 47.3492 228.353C47.4285 229.486 47.5531 231.207 47.689 233.359C47.9834 237.719 48.3572 244.016 48.8215 251.797C49.6822 267.369 50.7015 288.899 51.7321 312.671C52.7628 336.443 53.7367 357.973 54.5069 373.557C54.9033 381.326 55.2204 387.623 55.4469 392.006C55.5602 394.169 55.6394 395.845 55.6961 397.023C55.6961 397.578 55.6961 398.008 55.7527 398.326C55.7602 398.473 55.7602 398.62 55.7527 398.767C55.7527 398.767 55.7527 398.62 55.6961 398.326C55.6394 398.031 55.6961 397.578 55.6055 397.023C55.5262 395.891 55.4016 394.169 55.2657 392.017C54.9712 387.668 54.5975 381.36 54.1331 373.579C53.2724 358.007 52.2531 336.477 51.2225 312.694C50.1919 288.91 49.2179 267.392 48.4478 251.819C48.0514 244.05 47.7343 237.753 47.5077 233.37C47.3945 231.207 47.3152 229.531 47.2586 228.353C47.2586 227.798 47.2586 227.368 47.2586 227.051C47.251 226.903 47.251 226.756 47.2586 226.609Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4775 269.159C32.7705 269.336 33.0374 269.553 33.2703 269.804C33.7573 270.246 34.4029 270.937 35.2749 271.73C36.9398 273.383 39.1822 275.728 41.6059 278.355L47.7782 285.15L49.6583 287.189C49.9047 287.425 50.125 287.687 50.3151 287.971C50.0246 287.79 49.7581 287.573 49.5224 287.325C49.0354 286.883 48.3898 286.192 47.5291 285.388C45.8756 283.723 43.6671 281.356 41.2434 278.729L35.0258 272.013L33.1344 269.986C32.8853 269.735 32.665 269.458 32.4775 269.159Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5729 287.529C51.471 287.427 56.1031 282.591 61.8791 276.724C67.6551 270.858 72.4458 266.169 72.5364 266.26C72.627 266.35 68.0062 271.198 62.2189 277.064C56.4316 282.931 51.6635 287.608 51.5729 287.529Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5166 324.098C51.7857 323.876 52.0827 323.689 52.4 323.543L54.8689 322.15C56.9528 321.018 59.8182 319.353 62.9213 317.45C66.0245 315.548 68.7879 313.724 70.7812 312.399L73.1369 310.825C73.415 310.616 73.715 310.437 74.0316 310.293C74.0316 310.293 73.7711 310.565 73.2502 310.984C72.7292 311.403 71.9477 311.98 70.9851 312.682C69.0484 314.087 66.3077 315.955 63.1931 317.858C60.0786 319.761 57.168 321.358 55.0388 322.456C53.9742 323 53.1022 323.43 52.4906 323.702C52.1845 323.876 51.8571 324.009 51.5166 324.098Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5986 311.312C30.9086 311.402 31.2028 311.54 31.4707 311.72C32.0143 312.003 32.8071 312.445 33.7358 312.988C35.6611 314.121 38.266 315.616 41.1993 317.337C44.1326 319.059 46.7034 320.656 48.5835 321.868C49.5235 322.445 50.2823 322.921 50.8486 323.272C51.1319 323.427 51.3945 323.617 51.63 323.838C51.321 323.746 51.0272 323.608 50.758 323.431L48.4929 322.162C46.5675 321.029 43.9627 319.523 41.0294 317.802C38.0961 316.08 35.5252 314.495 33.6452 313.328C32.7052 312.739 31.9464 312.264 31.3801 311.924C31.097 311.751 30.8347 311.545 30.5986 311.312Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4531 343.59C26.8491 343.725 27.229 343.903 27.5857 344.122L30.519 345.753C32.9879 347.134 36.3856 349.082 40.123 351.257C43.8604 353.431 47.2353 355.413 49.659 356.92L52.5243 358.664C52.8822 358.865 53.2197 359.1 53.5323 359.366C53.1363 359.231 52.7564 359.052 52.3997 358.834L49.4665 357.214C46.9975 355.821 43.5999 353.884 39.8625 351.71C36.1251 349.535 32.7501 347.542 30.3264 346.047L27.4158 344.292C27.0706 344.093 26.7479 343.858 26.4531 343.59Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9658 358.777C53.3188 358.496 53.6981 358.249 54.0984 358.041L57.1676 356.172C59.7611 354.598 63.3286 352.401 67.2019 349.875C71.0752 347.35 74.5408 344.983 77.0211 343.25L79.9771 341.2C80.3309 340.927 80.7101 340.688 81.1096 340.487C80.7968 340.8 80.4597 341.087 80.1016 341.347C79.4334 341.88 78.4594 342.616 77.2363 343.522C74.8013 345.334 71.3697 347.758 67.4851 350.317C63.6004 352.877 59.9989 354.994 57.3601 356.501C56.035 357.248 54.9591 357.848 54.2116 358.234C53.816 358.457 53.3985 358.639 52.9658 358.777Z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9473 380.567H37.0195L48.4129 466.867H60.5425L71.9473 380.567Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.832 391.179C38.832 391.179 38.832 391.293 39.0132 391.485C39.246 391.748 39.5368 391.954 39.8626 392.085C40.4702 392.295 41.1176 392.363 41.7554 392.284C42.3932 392.206 43.0048 391.983 43.5434 391.632C44.9591 390.851 46.1823 389.367 48.0736 388.654C50.1718 387.977 52.436 388.021 54.5065 388.778C56.6122 389.513 58.6203 390.502 60.4863 391.723C62.046 392.699 63.6691 393.569 65.3449 394.328C66.4876 394.84 67.6959 395.19 68.9351 395.37C69.2693 395.414 69.606 395.436 69.9431 395.438C70.1809 395.438 70.3055 395.438 70.3055 395.438C68.649 395.185 67.0363 394.701 65.5148 393.999C63.877 393.196 62.2886 392.296 60.7581 391.304C58.8662 390.046 56.8178 389.041 54.665 388.314C52.4742 387.519 50.0785 387.491 47.8697 388.235C46.9356 388.613 46.0736 389.149 45.3215 389.82C44.688 390.377 44.0184 390.892 43.3169 391.361C42.8272 391.699 42.2701 391.928 41.6837 392.032C41.0973 392.136 40.4954 392.111 39.9193 391.961C39.5136 391.766 39.1456 391.502 38.832 391.179Z",
    fill: "#41525B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1006 407.069C40.1006 407.069 40.3837 406.718 40.9273 406.14C41.7188 405.358 42.6689 404.756 43.7134 404.373C45.269 403.812 46.9199 403.562 48.572 403.637C50.6137 403.794 52.6444 404.07 54.6538 404.464C56.7008 404.868 58.7978 404.956 60.8715 404.724C62.5669 404.509 64.2201 404.04 65.7754 403.331C66.8193 402.858 67.807 402.269 68.72 401.576C69.0726 401.348 69.3862 401.065 69.6487 400.738C68.3621 401.591 67.0145 402.348 65.6168 403.003C64.0829 403.642 62.4662 404.062 60.8148 404.249C58.7878 404.444 56.7431 404.345 54.7444 403.954C52.7152 403.549 50.6604 403.284 48.5947 403.161C46.875 403.099 45.1615 403.4 43.5662 404.045C42.487 404.475 41.5275 405.159 40.7688 406.038C40.5652 406.276 40.3868 406.534 40.2365 406.808C40.1783 406.888 40.1325 406.976 40.1006 407.069Z",
    fill: "#41525B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9947 415.574C67.7025 415.358 67.3775 415.19 67.032 415.076C66.1008 414.729 65.1242 414.52 64.1327 414.453C62.6708 414.371 61.2042 414.454 59.7611 414.702C58.1302 414.974 56.3634 415.416 54.5514 415.835C52.8441 416.236 51.0954 416.434 49.3417 416.424C47.9236 416.386 46.5252 416.083 45.2192 415.529C44.0422 414.963 42.9938 414.161 42.1387 413.173C42.2701 413.513 42.4706 413.821 42.7276 414.079C43.3872 414.835 44.1972 415.444 45.1059 415.869C46.4456 416.499 47.8968 416.857 49.3756 416.922C51.174 416.97 52.971 416.783 54.7213 416.367C56.5786 415.971 58.3114 415.506 59.897 415.235C61.3031 414.961 62.7346 414.839 64.1667 414.872C65.4663 414.952 66.7515 415.187 67.9947 415.574Z",
    fill: "#41525B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1918 427.545C44.2611 427.08 45.4492 426.961 46.5895 427.206C47.8214 427.51 49.0146 427.955 50.1457 428.531C51.5916 429.221 53.1483 429.651 54.7438 429.799C57.6647 430.055 60.5914 429.377 63.102 427.862C63.8518 427.406 64.5504 426.871 65.1859 426.266C65.6049 425.813 65.8201 425.552 65.7975 425.518C64.8708 426.239 63.9027 426.904 62.8981 427.511C60.4269 428.869 57.6102 429.468 54.8004 429.233C51.4821 429.097 48.9338 427.07 46.6688 426.832C45.7882 426.677 44.8823 426.755 44.0412 427.058C43.4183 427.262 43.1692 427.523 43.1918 427.545Z",
    fill: "#41525B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1397 444.114C46.1415 444.135 47.1354 443.934 48.0504 443.526C49.8058 442.948 51.9803 441.6 54.5172 440.592C55.6984 440.111 56.9568 439.846 58.232 439.811C59.2628 439.815 60.2798 440.047 61.2106 440.49C62.059 440.948 62.7972 441.586 63.3737 442.359C63.3257 442.088 63.2087 441.835 63.034 441.623C62.6118 441.005 62.049 440.497 61.3918 440.139C60.42 439.601 59.3312 439.31 58.2206 439.29C56.8767 439.289 55.5455 439.55 54.302 440.06C51.6745 441.102 49.568 442.495 47.8918 443.152C46.2157 443.809 45.1284 444.024 45.1397 444.114Z",
    fill: "#41525B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8496 451.816C47.5652 452.165 48.3285 452.405 49.1147 452.529C50.9322 452.974 52.7792 453.288 54.6415 453.469C56.5229 453.657 58.4153 453.71 60.3043 453.628C61.0681 453.64 61.8299 453.548 62.5693 453.356C62.5693 453.186 59.0358 453.356 54.7095 452.903C50.3831 452.45 46.8949 451.646 46.8496 451.816Z",
    fill: "#41525B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M754.714 23.8494L690.419 0.768066L626.736 23.5436C618.604 27.3829 611.481 29.682 611.481 37.236V74.9611C611.368 101.438 618.631 127.423 632.455 150.004C646.256 172.833 666.718 190.887 691.087 201.738C717.136 193.29 736.548 170.741 748.417 151.465C762.251 128.892 769.519 102.908 769.403 76.4335V42.525C769.358 31.7205 763.627 26.4542 754.714 23.8494Z",
    fill: "#41525B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M691.087 179.858C668.686 169.88 654.132 153.809 644.732 138.588C633.794 120.724 628.048 100.166 628.14 79.2195V52.7746C628.14 46.7834 631.753 41.166 638.934 37.8136L690.476 18.5604V0.768066L626.736 23.5436C620.054 26.4655 611.481 29.682 611.481 37.2587V74.9611C611.368 101.438 618.631 127.423 632.455 150.004C646.256 172.833 666.718 190.887 691.087 201.738V179.858Z",
    fill: "#37474F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M691.088 201.738C695.449 200.311 699.675 198.5 703.716 196.325C713.634 190.696 722.648 183.606 730.455 175.293C737.538 167.661 743.773 159.284 749.052 150.309C763.074 127.579 770.159 101.251 769.438 74.5534V43.4197C769.438 27.9152 761.51 26.7713 754.715 23.8494L690.42 0.768066V18.549L742.517 38.1308C749.697 41.5284 753.31 47.0892 753.31 53.0804V79.5253C753.4 100.473 747.65 121.031 736.707 138.893C727.33 154.149 713.445 169.88 691.088 179.858V201.738Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M707.475 77.5206L707.543 72.4354C707.543 68.008 705.785 63.7619 702.654 60.6312C699.523 57.5005 695.277 55.7417 690.85 55.7417C686.422 55.7417 682.176 57.5005 679.045 60.6312C675.915 63.7619 674.156 68.008 674.156 72.4354L674.088 77.6112C671.882 77.9493 669.87 79.0659 668.416 80.759C666.962 82.452 666.161 84.6096 666.16 86.8414V116.854C666.16 119.332 667.145 121.709 668.897 123.461C670.649 125.213 673.026 126.197 675.504 126.197H706.671C709.149 126.197 711.526 125.213 713.278 123.461C715.03 121.709 716.015 119.332 716.015 116.854V86.8414C716.018 84.5005 715.142 82.2437 713.561 80.5177C711.979 78.7916 709.808 77.722 707.475 77.5206ZM695.301 109.368H687.158L688.426 103.479C687.518 102.912 686.817 102.067 686.429 101.07C686.041 100.072 685.985 98.9758 686.271 97.9444C686.557 96.9129 687.169 96.0016 688.016 95.3466C688.862 94.6915 689.898 94.3279 690.968 94.3099C692.038 94.2919 693.086 94.6205 693.954 95.2468C694.822 95.873 695.464 96.7632 695.784 97.7845C696.105 98.8057 696.086 99.9032 695.732 100.913C695.377 101.923 694.706 102.791 693.817 103.388L695.301 109.368ZM703.874 77.4753H677.689L677.757 72.4354C677.858 69.0283 679.282 65.7943 681.727 63.4198C684.172 61.0453 687.447 59.7171 690.855 59.7171C694.264 59.7171 697.538 61.0453 699.984 63.4198C702.429 65.7943 703.853 69.0283 703.953 72.4354L703.874 77.4753Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M638.515 77.1582C637.973 75.466 637.649 73.7114 637.552 71.9371C637.075 67.6852 636.9 63.4047 637.031 59.128C637.099 56.6251 637.269 54.2468 637.496 52.0836C637.597 50.1197 638.086 48.1952 638.934 46.4209C639.556 45.2101 640.537 44.2212 641.743 43.5895C642.615 43.1818 643.159 43.2044 643.17 43.2611C641.619 43.9836 640.369 45.2255 639.636 46.772C638.938 48.5022 638.555 50.3431 638.504 52.2082C638.334 54.3487 638.198 56.7384 638.13 59.1847C637.983 64.1452 638.13 68.6414 638.323 71.8918C638.515 75.1422 638.685 77.1355 638.515 77.1582Z",
    fill: "#41525B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M639.466 93.569C639.149 93.569 638.866 92.0287 638.832 90.1034C638.798 88.1781 639.013 86.6265 639.319 86.6265C639.624 86.6265 639.919 88.1667 639.953 90.0241C639.987 91.8815 639.772 93.5576 639.466 93.569Z",
    fill: "#41525B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M783.526 466.935C783.526 467.105 610.643 467.23 397.442 467.23C184.24 467.23 11.334 467.105 11.334 466.935C11.334 466.765 184.172 466.641 397.442 466.641C610.711 466.641 783.526 466.777 783.526 466.935Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M645.786 32.7737H154.261C150.199 32.7827 146.306 34.4019 143.436 37.2764C140.566 40.1509 138.952 44.0462 138.949 48.1084V395.222C138.949 399.286 140.561 403.185 143.432 406.062C146.303 408.939 150.197 410.559 154.261 410.568H342.909C342.909 410.568 354.903 447.671 317.71 466.867H494.082C494.082 466.867 452.121 452.473 462.88 410.568H645.786C649.854 410.565 653.755 408.947 656.63 406.07C659.506 403.192 661.121 399.29 661.121 395.222V48.1084C661.121 44.0413 659.505 40.1409 656.629 37.2651C653.754 34.3893 649.853 32.7737 645.786 32.7737Z",
    fill: "#455A64"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M406.581 374.055C413.263 383.614 402.799 394.079 393.24 387.397C392.922 387.171 392.646 386.891 392.425 386.57C385.754 377.023 396.207 366.569 405.755 373.24C406.073 373.464 406.353 373.74 406.581 374.055Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M158.395 39.1274H641.63C644.543 39.1274 647.337 40.2849 649.398 42.3451C651.458 44.4053 652.615 47.1996 652.615 50.1131V347.067H147.466V50.1131C147.466 47.2093 148.615 44.4236 150.663 42.365C152.711 40.3064 155.491 39.1424 158.395 39.1274Z",
    fill: "#41525B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157.783 39.1274H644.099C646.352 39.1364 648.509 40.0377 650.099 41.6339C651.689 43.2301 652.581 45.3913 652.581 47.6442V64.7117H147.466V49.4902C147.466 46.7497 148.551 44.1207 150.485 42.1786C152.419 40.2365 155.043 39.1394 157.783 39.1274Z",
    fill: "#37474F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M163.503 56.0023C165.461 56.0023 167.048 54.4152 167.048 52.4575C167.048 50.4997 165.461 48.9126 163.503 48.9126C161.545 48.9126 159.958 50.4997 159.958 52.4575C159.958 54.4152 161.545 56.0023 163.503 56.0023Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M174.081 56.0023C176.039 56.0023 177.626 54.4152 177.626 52.4575C177.626 50.4997 176.039 48.9126 174.081 48.9126C172.123 48.9126 170.536 50.4997 170.536 52.4575C170.536 54.4152 172.123 56.0023 174.081 56.0023Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M184.138 56.0023C186.095 56.0023 187.683 54.4152 187.683 52.4575C187.683 50.4997 186.095 48.9126 184.138 48.9126C182.18 48.9126 180.593 50.4997 180.593 52.4575C180.593 54.4152 182.18 56.0023 184.138 56.0023Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M557.878 410.614C557.878 410.784 487.943 410.908 401.7 410.908C315.456 410.908 245.499 410.784 245.499 410.614C245.499 410.444 315.422 410.32 401.7 410.32C487.977 410.32 557.878 410.455 557.878 410.614Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M478.044 108.043L401.031 79.6726L324.754 107.669C315.014 112.381 306.475 115.212 306.475 124.51V170.877C306.316 203.327 315.004 235.206 331.606 263.088C345.831 286.77 367.847 311.154 401.824 326.658C433.003 316.273 456.277 288.582 470.501 264.889C487.104 237.012 495.793 205.135 495.633 172.689V130.988C495.576 117.715 488.724 111.237 478.044 108.043Z",
    fill: "url(#paint0_linear_2162_5563)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.045 108.043L401.032 79.6726L324.755 107.669C315.015 112.381 306.476 115.212 306.476 124.51V170.877C306.317 203.327 315.005 235.206 331.607 263.088C345.832 286.77 367.848 311.154 401.825 326.658C433.004 316.273 456.278 288.582 470.502 264.889C487.105 237.012 495.794 205.135 495.634 172.689V130.988C495.577 117.715 488.725 111.237 478.045 108.043Z",
    fill: "#41525B"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M448.055 225.329H433.898V148.316C433.898 139.595 430.434 131.231 424.267 125.064C418.1 118.897 409.736 115.433 401.015 115.433C392.293 115.433 383.929 118.897 377.763 125.064C371.596 131.231 368.131 139.595 368.131 148.316V225.329H353.974V148.316C353.878 142.077 355.023 135.882 357.343 130.09C359.664 124.298 363.113 119.025 367.491 114.579C371.869 110.133 377.087 106.602 382.843 104.192C388.598 101.781 394.775 100.54 401.015 100.54C407.254 100.54 413.432 101.781 419.187 104.192C424.942 106.602 430.161 110.133 434.538 114.579C438.916 119.025 442.366 124.298 444.686 130.09C447.007 135.882 448.152 142.077 448.055 148.316V225.329Z",
    fill: "url(#paint1_linear_2162_5563)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.055 225.329H433.898V148.316C433.898 139.595 430.434 131.231 424.267 125.064C418.1 118.897 409.736 115.433 401.015 115.433C392.293 115.433 383.929 118.897 377.763 125.064C371.596 131.231 368.131 139.595 368.131 148.316V225.329H353.974V148.316C353.878 142.077 355.023 135.882 357.343 130.09C359.664 124.298 363.113 119.025 367.491 114.579C371.869 110.133 377.087 106.602 382.843 104.192C388.598 101.781 394.775 100.54 401.015 100.54C407.254 100.54 413.432 101.781 419.187 104.192C424.942 106.602 430.161 110.133 434.538 114.579C438.916 119.025 442.366 124.298 444.686 130.09C447.007 135.882 448.152 142.077 448.055 148.316V225.329Z",
    fill: "black"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M457.829 191.059H344.2C340.566 191.059 337.62 194.005 337.62 197.639V265.818C337.62 269.452 340.566 272.398 344.2 272.398H457.829C461.463 272.398 464.409 269.452 464.409 265.818V197.639C464.409 194.005 461.463 191.059 457.829 191.059Z",
    fill: "url(#paint2_linear_2162_5563)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.609 221.139C411.611 219.166 411.062 217.233 410.024 215.555C408.986 213.878 407.501 212.523 405.735 211.644C403.97 210.764 401.994 210.395 400.03 210.577C398.066 210.759 396.192 211.485 394.618 212.675C393.044 213.864 391.833 215.469 391.122 217.308C390.41 219.148 390.226 221.15 390.59 223.088C390.954 225.027 391.852 226.826 393.182 228.282C394.513 229.738 396.223 230.794 398.121 231.332V247.187H403.908V231.332C406.128 230.706 408.083 229.371 409.474 227.531C410.864 225.691 411.614 223.446 411.609 221.139Z",
    fill: "black"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M344.381 264.685C344.087 264.685 343.86 251.095 343.86 234.39C343.86 217.685 344.087 204.094 344.381 204.094C344.676 204.094 344.914 217.685 344.914 234.39C344.914 251.095 344.676 264.685 344.381 264.685Z",
    fill: "#41525B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M392.718 234.718C392.718 234.718 392.22 234.56 391.472 234.016C390.425 233.233 389.504 232.293 388.743 231.23C387.421 229.485 386.501 227.47 386.049 225.328C385.597 223.187 385.625 220.972 386.129 218.842C386.633 216.712 387.602 214.72 388.967 213.008C390.331 211.297 392.057 209.908 394.021 208.941C395.195 208.335 396.456 207.911 397.758 207.684C398.223 207.557 398.709 207.53 399.185 207.605C399.185 207.809 397.18 208.001 394.428 209.598C392.632 210.591 391.063 211.949 389.823 213.585C388.582 215.22 387.697 217.097 387.225 219.094C386.752 221.092 386.703 223.166 387.079 225.184C387.456 227.201 388.25 229.118 389.411 230.811C390.405 232.201 391.511 233.508 392.718 234.718Z",
    fill: "#41525B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M496.29 308.662C496.29 308.662 496.596 308.232 497.207 307.427L497.717 306.748C497.898 306.487 498.057 306.182 498.238 305.853C498.689 305.118 499.069 304.34 499.371 303.531C499.552 303.067 499.767 302.591 499.948 302.07C500.129 301.55 500.254 300.938 500.412 300.394C500.597 299.784 500.726 299.159 500.798 298.526C500.933 297.844 501.031 297.156 501.092 296.464C501.36 293.148 501.207 289.81 500.639 286.532C499.506 279.091 496.335 270.348 491.511 260.834C485.914 250.108 479.356 239.911 471.918 230.369C462.962 218.748 453.198 207.772 442.698 197.525C430.703 185.721 417.889 174.779 404.35 164.783C397.181 159.528 389.627 154.42 381.699 149.607C373.596 144.668 365.182 140.257 356.511 136.402C347.574 132.319 338.161 129.37 328.492 127.624C323.556 126.747 318.516 126.621 313.542 127.251C311.055 127.624 308.629 128.329 306.328 129.346C304.012 130.376 301.94 131.885 300.248 133.772C298.555 135.659 297.281 137.883 296.509 140.298C295.758 142.699 295.335 145.19 295.252 147.704C295.181 152.718 295.873 157.712 297.302 162.518C300.135 171.928 304.138 180.946 309.216 189.36C314.033 197.541 319.375 205.402 325.208 212.894C330.87 220.255 336.828 227.175 342.864 233.687C354.337 246.008 366.667 257.502 379.762 268.083C391.135 277.343 403.143 285.793 415.698 293.373C426.024 299.673 436.899 305.026 448.191 309.364C458.191 313.079 467.24 315.208 474.76 315.503C478.083 315.704 481.417 315.476 484.681 314.823C485.358 314.688 486.027 314.518 486.686 314.313C487.308 314.158 487.917 313.957 488.509 313.713L490.118 313.056C490.616 312.818 491.069 312.547 491.499 312.32C492.269 311.91 493.001 311.433 493.685 310.893C493.98 310.667 494.274 310.485 494.512 310.281L495.123 309.693L496.256 308.639L495.18 309.772L494.569 310.383C494.331 310.587 494.048 310.78 493.742 311.018C493.061 311.564 492.334 312.049 491.567 312.467C491.137 312.705 490.684 312.977 490.186 313.226L488.566 313.894C487.976 314.149 487.366 314.353 486.743 314.506C486.081 314.722 485.408 314.903 484.727 315.049C481.449 315.718 478.1 315.966 474.76 315.786C467.206 315.525 458.123 313.407 448.089 309.727C436.762 305.408 425.852 300.067 415.494 293.769C402.9 286.214 390.86 277.77 379.468 268.502C366.34 257.926 353.979 246.432 342.479 234.106C336.42 227.583 330.474 220.652 324.777 213.279C318.927 205.772 313.566 197.896 308.729 189.699C303.627 181.241 299.601 172.179 296.747 162.722C295.307 157.849 294.616 152.785 294.697 147.704C294.777 145.132 295.212 142.582 295.988 140.128C296.774 137.634 298.08 135.336 299.82 133.384C301.559 131.431 303.692 129.87 306.079 128.802C308.427 127.756 310.908 127.036 313.452 126.662C318.485 126.015 323.587 126.141 328.583 127.035C338.301 128.787 347.761 131.755 356.738 135.869C365.407 139.743 373.814 144.181 381.903 149.154C389.831 153.979 397.441 159.098 404.554 164.364C418.105 174.395 430.931 185.37 442.936 197.208C453.43 207.478 463.187 218.476 472.133 230.12C479.565 239.699 486.112 249.934 491.692 260.699C496.494 270.246 499.62 279.035 500.752 286.498C501.31 289.797 501.443 293.154 501.149 296.487C501.089 297.183 500.99 297.875 500.854 298.56C500.765 299.195 500.628 299.824 500.446 300.44C500.277 301.029 500.118 301.572 499.971 302.127C499.824 302.682 499.552 303.124 499.371 303.588C499.05 304.401 498.647 305.178 498.17 305.91C497.977 306.238 497.819 306.544 497.638 306.805L497.105 307.473C496.573 308.266 496.29 308.662 496.29 308.662Z",
    fill: "url(#paint3_linear_2162_5563)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M532.531 221.15C532.531 221.15 532.475 220.629 532.395 219.621C532.395 219.365 532.373 219.081 532.327 218.772C532.327 218.455 532.191 218.126 532.123 217.753C531.975 216.895 531.748 216.054 531.444 215.238C531.274 214.774 531.115 214.276 530.912 213.766C530.708 213.256 530.402 212.758 530.13 212.203C529.845 211.614 529.512 211.05 529.133 210.516C528.76 209.972 528.443 209.383 528.001 208.794C525.995 206.137 523.658 203.747 521.047 201.682C515.237 196.902 507.06 192.463 497.139 188.578C485.82 184.301 474.137 181.057 462.234 178.884C447.821 176.18 433.236 174.496 418.586 173.844C401.773 173.035 384.924 173.414 368.165 174.976C359.32 175.814 350.282 177.038 341.142 178.748C331.806 180.453 322.591 182.76 313.553 185.656C304.156 188.556 295.158 192.62 286.769 197.752C282.53 200.39 278.713 203.651 275.443 207.424C273.832 209.355 272.49 211.496 271.457 213.789C270.417 216.104 269.88 218.613 269.88 221.15C269.88 223.688 270.417 226.197 271.457 228.512C272.495 230.802 273.835 232.943 275.443 234.877C278.713 238.633 282.532 241.875 286.769 244.492C295.153 249.629 304.147 253.697 313.542 256.599C322.579 259.498 331.795 261.805 341.131 263.507C350.271 265.229 359.308 266.441 368.153 267.279C384.912 268.847 401.762 269.226 418.574 268.411C433.224 267.76 447.81 266.076 462.223 263.372C474.127 261.202 485.81 257.957 497.128 253.677C507.06 249.792 515.248 245.353 521.036 240.573C523.65 238.511 525.987 236.121 527.99 233.461C528.398 232.908 528.776 232.333 529.122 231.74C529.486 231.216 529.804 230.663 530.073 230.086L530.855 228.523C531.059 228.013 531.217 227.515 531.387 227.051C531.691 226.236 531.919 225.394 532.067 224.537C532.135 224.174 532.225 223.834 532.271 223.529C532.316 223.223 532.271 222.928 532.339 222.679C532.418 221.66 532.475 221.15 532.475 221.15C532.475 221.15 532.475 221.671 532.395 222.679C532.395 222.94 532.395 223.223 532.395 223.54C532.395 223.857 532.271 224.185 532.203 224.559C532.062 225.419 531.842 226.265 531.546 227.085C531.376 227.56 531.229 228.059 531.014 228.58L530.255 230.154C529.983 230.734 529.665 231.291 529.303 231.819C528.93 232.374 528.613 233.008 528.171 233.574C526.168 236.258 523.827 238.671 521.206 240.755C515.396 245.579 507.207 250.064 497.275 253.983C485.94 258.286 474.238 261.554 462.313 263.745C447.884 266.482 433.279 268.196 418.608 268.876C401.771 269.717 384.896 269.365 368.108 267.822C359.252 266.984 350.203 265.773 341.029 264.062C331.671 262.358 322.433 260.05 313.372 257.154C303.93 254.239 294.89 250.152 286.463 244.99C282.15 242.321 278.264 239.019 274.934 235.194C273.284 233.215 271.912 231.02 270.856 228.67C269.792 226.288 269.242 223.708 269.242 221.099C269.242 218.49 269.792 215.91 270.856 213.528C271.917 211.184 273.288 208.994 274.934 207.016C278.262 203.188 282.154 199.889 286.474 197.231C294.895 192.068 303.932 187.986 313.372 185.079C322.431 182.174 331.669 179.862 341.029 178.159C350.191 176.449 359.24 175.237 368.097 174.399C384.884 172.859 401.76 172.511 418.597 173.357C433.273 174.037 447.882 175.76 462.313 178.51C474.232 180.711 485.926 183.99 497.252 188.306C507.196 192.236 515.373 196.71 521.194 201.535C523.806 203.626 526.139 206.043 528.137 208.726C528.545 209.287 528.923 209.869 529.269 210.47C529.626 211.002 529.944 211.558 530.221 212.135L530.98 213.721C531.195 214.23 531.342 214.74 531.512 215.204C531.81 216.028 532.029 216.877 532.169 217.741C532.237 218.104 532.316 218.443 532.361 218.761C532.407 219.078 532.361 219.361 532.361 219.61C532.531 220.629 532.531 221.15 532.531 221.15Z",
    fill: "url(#paint4_linear_2162_5563)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M484.466 112.211C484.466 112.211 484.013 111.939 483.175 111.384L482.462 110.92C482.19 110.761 481.861 110.625 481.533 110.455C480.764 110.051 479.961 109.718 479.132 109.459C478.656 109.311 478.169 109.119 477.637 108.972L475.904 108.587C475.282 108.45 474.649 108.363 474.013 108.326C473.345 108.326 472.665 108.156 471.94 108.179C468.61 108.139 465.288 108.52 462.053 109.311C454.726 110.965 446.198 114.714 437.058 120.184C426.74 126.504 417.016 133.748 408.008 141.827C397.04 151.559 386.772 162.054 377.282 173.232C366.333 186.016 356.3 199.558 347.258 213.755C342.502 221.264 337.926 229.146 333.668 237.425C329.3 245.853 325.479 254.554 322.229 263.474C318.78 272.673 316.497 282.269 315.434 292.036C314.897 297.021 315.123 302.058 316.102 306.975C316.637 309.433 317.506 311.807 318.684 314.03C319.874 316.264 321.522 318.22 323.52 319.772C325.519 321.324 327.823 322.435 330.281 323.034C332.728 323.622 335.242 323.873 337.756 323.782C342.761 323.505 347.695 322.47 352.389 320.712C361.585 317.235 370.309 312.62 378.358 306.975C386.187 301.606 393.658 295.735 400.726 289.397C407.68 283.225 414.18 276.826 420.262 270.348C431.744 258.054 442.341 244.963 451.974 231.173C460.447 219.207 468.065 206.657 474.772 193.618C480.343 182.879 484.934 171.659 488.487 160.095C491.499 149.902 493.017 140.694 492.779 133.174C492.751 129.845 492.295 126.533 491.42 123.321C491.237 122.653 491.018 121.995 490.763 121.35C490.573 120.743 490.334 120.153 490.05 119.584C489.778 119.04 489.529 118.451 489.291 118.021C489.053 117.59 488.713 117.103 488.453 116.696C487.994 115.954 487.467 115.256 486.879 114.612C486.641 114.329 486.426 114.057 486.21 113.83L485.576 113.253C484.829 112.573 484.444 112.211 484.444 112.211L485.576 113.207L486.21 113.774C486.437 114 486.652 114.272 486.901 114.555C487.504 115.189 488.039 115.884 488.498 116.628C488.77 117.047 489.076 117.477 489.359 117.953L490.129 119.516C490.428 120.086 490.678 120.681 490.876 121.294C491.08 121.928 491.386 122.562 491.545 123.276C492.439 126.497 492.918 129.82 492.972 133.163C493.232 140.717 491.749 149.924 488.759 160.185C485.234 171.784 480.662 183.039 475.1 193.811C468.42 206.89 460.824 219.481 452.37 231.49C442.739 245.31 432.142 258.432 420.659 270.756C414.566 277.257 408.065 283.667 401.1 289.862C394.015 296.216 386.524 302.103 378.675 307.484C370.606 313.161 361.854 317.799 352.627 321.29C347.852 323.087 342.828 324.137 337.734 324.404C335.162 324.493 332.591 324.234 330.089 323.634C327.552 323.017 325.174 321.87 323.111 320.27C321.049 318.669 319.347 316.651 318.118 314.347C316.913 312.074 316.025 309.647 315.479 307.133C314.491 302.16 314.262 297.066 314.8 292.025C315.883 282.205 318.192 272.56 321.674 263.315C324.937 254.394 328.773 245.693 333.158 237.266C337.416 228.976 342.003 221.082 346.749 213.562C355.814 199.354 365.874 185.805 376.852 173.017C386.376 161.836 396.677 151.341 407.68 141.612C416.741 133.502 426.525 126.238 436.911 119.912C446.107 114.453 454.658 110.727 462.031 109.096C465.278 108.29 468.617 107.909 471.963 107.964C472.66 107.98 473.355 108.033 474.047 108.122C474.687 108.163 475.323 108.254 475.95 108.394L477.671 108.756C478.203 108.915 478.69 109.096 479.166 109.255C479.998 109.52 480.802 109.865 481.567 110.285C481.907 110.455 482.224 110.602 482.496 110.761L483.198 111.237C484.047 111.905 484.466 112.211 484.466 112.211Z",
    fill: "url(#paint5_linear_2162_5563)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M264.651 283.746C267.347 283.746 269.532 281.561 269.532 278.865C269.532 276.169 267.347 273.983 264.651 273.983C261.955 273.983 259.77 276.169 259.77 278.865C259.77 281.561 261.955 283.746 264.651 283.746Z",
    fill: "url(#paint6_linear_2162_5563)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M543.608 124.102C543.606 125.067 543.318 126.01 542.78 126.811C542.242 127.612 541.479 128.236 540.587 128.604C539.695 128.972 538.714 129.067 537.768 128.877C536.822 128.687 535.953 128.222 535.271 127.539C534.59 126.855 534.126 125.986 533.939 125.039C533.751 124.093 533.849 123.112 534.218 122.22C534.588 121.329 535.214 120.567 536.016 120.032C536.819 119.496 537.762 119.21 538.727 119.21C539.369 119.21 540.005 119.336 540.598 119.582C541.191 119.828 541.729 120.189 542.183 120.643C542.636 121.098 542.995 121.637 543.24 122.231C543.485 122.824 543.61 123.46 543.608 124.102Z",
    fill: "url(#paint7_linear_2162_5563)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M298.933 291.47C298.933 291.717 298.86 291.958 298.722 292.163C298.585 292.368 298.39 292.528 298.161 292.622C297.933 292.716 297.682 292.74 297.44 292.691C297.198 292.642 296.976 292.522 296.802 292.347C296.629 292.171 296.511 291.948 296.464 291.706C296.417 291.464 296.443 291.213 296.54 290.985C296.636 290.758 296.797 290.564 297.003 290.429C297.21 290.293 297.452 290.222 297.699 290.224C298.027 290.227 298.341 290.36 298.572 290.593C298.803 290.826 298.933 291.142 298.933 291.47Z",
    fill: "url(#paint8_linear_2162_5563)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M325.423 154.636C325.423 154.882 325.35 155.123 325.213 155.328C325.076 155.533 324.882 155.692 324.654 155.787C324.427 155.881 324.176 155.906 323.934 155.858C323.693 155.809 323.471 155.691 323.297 155.517C323.122 155.342 323.004 155.12 322.956 154.879C322.908 154.637 322.932 154.387 323.026 154.159C323.121 153.931 323.28 153.737 323.485 153.6C323.69 153.463 323.931 153.39 324.177 153.39C324.508 153.39 324.825 153.521 325.058 153.755C325.292 153.988 325.423 154.305 325.423 154.636Z",
    fill: "url(#paint9_linear_2162_5563)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M519.077 221.15C519.077 221.397 519.003 221.638 518.866 221.843C518.728 222.049 518.533 222.208 518.305 222.302C518.077 222.396 517.825 222.42 517.584 222.371C517.342 222.322 517.12 222.202 516.946 222.027C516.772 221.852 516.654 221.629 516.608 221.386C516.561 221.144 516.587 220.893 516.683 220.666C516.779 220.438 516.941 220.244 517.147 220.109C517.353 219.973 517.595 219.902 517.842 219.904C518.005 219.904 518.167 219.937 518.317 219.999C518.468 220.062 518.604 220.154 518.719 220.27C518.834 220.386 518.924 220.523 518.986 220.674C519.047 220.825 519.078 220.987 519.077 221.15Z",
    fill: "url(#paint10_linear_2162_5563)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M536.326 163.288C536.328 163.536 536.256 163.778 536.12 163.985C535.984 164.191 535.79 164.353 535.562 164.449C535.334 164.544 535.082 164.57 534.84 164.522C534.597 164.474 534.374 164.356 534.199 164.181C534.024 164.006 533.905 163.783 533.857 163.54C533.81 163.297 533.835 163.046 533.931 162.818C534.027 162.59 534.188 162.395 534.395 162.259C534.601 162.123 534.844 162.052 535.091 162.054C535.418 162.054 535.732 162.184 535.964 162.416C536.195 162.647 536.326 162.961 536.326 163.288Z",
    fill: "url(#paint11_linear_2162_5563)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M735.847 348.573C741.333 345.144 747.532 343.017 753.967 342.355C756.912 342.049 760.14 342.14 762.518 343.929C762.79 344.088 763.015 344.316 763.168 344.591C763.322 344.866 763.398 345.177 763.39 345.492C763.253 345.939 762.954 346.318 762.552 346.557C755.202 352.163 744.08 352.876 735.892 348.573",
    fill: "url(#paint12_linear_2162_5563)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M736.311 348.063C740.497 344.989 744.404 341.551 747.987 337.791C751.577 334.004 754.101 329.335 755.303 324.257C755.539 323.505 755.61 322.711 755.51 321.929C755.41 321.147 755.143 320.396 754.726 319.727C745.416 326.998 738.111 336.398 736.311 348.041",
    fill: "url(#paint13_linear_2162_5563)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M735.948 348.505C736.808 343.426 736.731 338.233 735.722 333.182C734.686 328.091 731.776 323.576 727.567 320.531C725.959 324.291 726.65 328.617 727.783 332.547C729.536 338.63 732.267 344.387 735.869 349.592",
    fill: "url(#paint14_linear_2162_5563)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M726.82 364.848C732.358 365.527 737.183 368.438 741.317 372.187C745.471 375.968 748.365 380.933 749.607 386.411C744.171 386.083 739.573 382.255 736.22 377.951C732.868 373.648 730.558 368.947 726.9 364.938",
    fill: "url(#paint15_linear_2162_5563)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M724.838 367.464C727.017 361.929 727.782 355.937 727.062 350.033C726.342 344.128 724.161 338.495 720.715 333.646C717.556 344.87 718.722 357.543 724.838 367.464Z",
    fill: "url(#paint16_linear_2162_5563)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M712.788 381.813C717.852 381.494 722.898 382.673 727.297 385.203C731.695 387.732 735.252 391.501 737.523 396.038C737.829 396.65 738.101 397.431 737.693 397.975C737.479 398.183 737.218 398.335 736.932 398.42C736.646 398.505 736.343 398.519 736.051 398.462C731.181 398.145 726.866 395.211 723.31 391.882C719.753 388.552 716.639 384.69 712.709 381.802",
    fill: "url(#paint17_linear_2162_5563)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M713.173 381.032C715.765 372.68 715.926 363.763 713.637 355.323C712.731 352.004 711.202 348.527 708.144 346.976C708.022 346.895 707.885 346.84 707.741 346.815C707.597 346.79 707.449 346.794 707.306 346.829C707.06 346.96 706.87 347.178 706.774 347.44C705.748 349.755 705.304 352.287 705.483 354.813C705.657 357.331 706.035 359.831 706.616 362.288C707.578 366.818 708.088 371.756 710.591 375.686C711.182 376.634 711.716 377.617 712.188 378.631C712.663 379.639 712.663 379.99 713.094 380.782",
    fill: "url(#paint18_linear_2162_5563)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M681.268 385.788C683.635 376.796 681.133 365.901 675.458 358.528C675.051 357.984 674.496 357.395 673.816 357.463C672.763 357.565 672.503 358.947 672.548 360C672.974 369.245 675.997 378.182 681.268 385.788Z",
    fill: "url(#paint19_linear_2162_5563)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M678.392 387.748C667.474 390.59 654.948 387.827 645.865 381.134C651.308 378.395 657.533 377.631 663.476 378.971C669.354 380.318 674.734 382.957 678.392 387.748Z",
    fill: "url(#paint20_linear_2162_5563)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M675.969 381.768C669.853 371.79 658.131 365.278 646.443 364.689C647.791 369.446 651.698 373.138 656.104 375.369C660.51 377.6 665.425 378.574 670.272 379.514C672.163 379.876 674.802 380.284 675.935 381.779",
    fill: "url(#paint21_linear_2162_5563)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M680.669 352.718C679.015 347.055 677.339 341.325 676.886 335.424C676.433 329.524 677.271 323.374 680.284 318.323C685.947 329.376 686.581 342.299 680.794 353.307",
    fill: "url(#paint22_linear_2162_5563)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M661.427 343.023C654.745 330.871 641.109 321.177 627.314 319.818C632.637 333.068 647.157 343.307 661.427 343.023Z",
    fill: "url(#paint23_linear_2162_5563)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M665.628 345.379C655.662 346.897 647.179 353.307 637.858 357.112C635.908 358.055 633.745 358.473 631.584 358.324C630.578 358.312 629.6 357.992 628.782 357.407C627.963 356.821 627.344 355.999 627.009 355.05C626.673 354.102 626.636 353.073 626.903 352.103C627.171 351.133 627.729 350.269 628.504 349.626C629.813 348.411 631.354 347.471 633.034 346.863C643.227 342.638 654.054 342.536 664.745 345.096",
    fill: "url(#paint24_linear_2162_5563)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M671.404 352.367C669.139 353.012 668.369 354.179 666.579 355.697C660.49 360.878 653.284 364.58 645.525 366.512C644.721 366.716 643.668 366.796 643.26 366.071C642.853 365.346 643.351 364.666 643.804 364.1C647.193 360.132 651.591 357.154 656.534 355.481C661.392 353.669 665.594 351.495 671.404 351.959",
    fill: "url(#paint25_linear_2162_5563)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M677.905 310.179C673.817 313.952 668.984 316.826 663.717 318.616C658.45 320.407 652.867 321.075 647.327 320.576C646.82 320.586 646.328 320.409 645.945 320.078C645.175 319.24 646.092 317.949 646.987 317.258C655.968 310.247 666.852 307.348 677.883 310.179",
    fill: "url(#paint26_linear_2162_5563)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M670.193 307.326C664.784 303.346 658.512 300.702 651.886 299.609C645.261 298.517 638.471 299.007 632.071 301.04C636.873 305.763 643.533 308.311 650.192 308.968C656.891 309.581 663.646 309.009 670.147 307.28",
    fill: "url(#paint27_linear_2162_5563)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M673.262 287.925C674.145 278.967 673.568 271.888 674.19 262.873C674.19 262.16 674.394 261.288 675.062 261.027C676.002 260.676 676.784 261.82 677.09 262.783C678.39 266.953 678.722 271.364 678.061 275.682C677.399 279.999 675.762 284.109 673.273 287.699",
    fill: "url(#paint28_linear_2162_5563)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M673.907 288.922C668.046 285.142 662.995 280.233 659.048 274.482C656.115 270.473 653.646 265.659 654.314 260.733C656.377 260.785 658.404 261.283 660.256 262.194C662.108 263.106 663.74 264.407 665.039 266.01C667.597 269.257 669.456 272.997 670.498 276.996C671.688 280.937 672.514 284.992 673.896 288.876",
    fill: "url(#paint29_linear_2162_5563)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M659.309 284.867C645.946 279.92 633.571 272.634 622.762 263.349C627.122 261.593 632.128 262.635 636.488 264.402C646.466 268.423 654.609 275.218 659.502 284.788",
    fill: "url(#paint30_linear_2162_5563)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M669.797 293.826C663.002 294.562 656.206 295.038 649.502 293.928C642.797 292.818 636.704 290.213 630.554 287.631C630.017 287.478 629.559 287.125 629.274 286.645C629.175 286.361 629.166 286.054 629.247 285.765C629.328 285.475 629.495 285.217 629.727 285.026C630.206 284.659 630.759 284.4 631.347 284.267C638.029 282.398 645.243 283.282 651.823 285.49C658.089 287.634 664.113 290.427 669.797 293.826Z",
    fill: "url(#paint31_linear_2162_5563)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M708.325 310.451C712.935 301.164 712.629 290.326 708.654 280.745C705.856 285.014 705.516 290.439 706.026 295.468C706.536 300.496 708.087 305.774 708.178 310.87",
    fill: "url(#paint32_linear_2162_5563)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M726.718 301.187C732.481 301.11 738.197 302.237 743.499 304.495C748.801 306.754 753.574 310.094 757.512 314.302C751.77 315.197 745.87 313.724 740.649 311.176C735.428 308.628 730.795 305.049 726.197 301.504",
    fill: "url(#paint33_linear_2162_5563)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M739.086 297.042C744.748 296.589 750.117 295.91 755.519 297.552C760.921 299.194 765.848 302.965 768.045 308.175C762.743 308.603 757.423 307.597 752.642 305.264C747.874 302.939 743.325 300.187 739.052 297.042",
    fill: "url(#paint34_linear_2162_5563)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M720.772 297.235C725.834 293.916 730.965 290.541 736.911 289.171C742.857 287.8 749.629 288.82 753.74 293.259C748.972 296.057 743.185 296.385 737.658 296.374C732.131 296.363 725.359 296.306 720.138 298.152",
    fill: "url(#paint35_linear_2162_5563)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M720.749 297.507C729.391 289.012 732.675 273.723 729.187 262.148C722.359 272.6 719.377 285.099 720.749 297.507Z",
    fill: "url(#paint36_linear_2162_5563)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M696.966 273.44C695.335 269.657 694.191 265.671 692.73 261.82C691.393 257.902 689.343 254.266 686.683 251.095C683.982 247.905 680.132 245.911 675.969 245.545C677.3 251.394 679.836 256.901 683.414 261.716C686.992 266.53 691.534 270.546 696.751 273.508",
    fill: "url(#paint37_linear_2162_5563)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M701.281 278.468C703.977 274.754 707.103 269.714 710.761 266.939C714.419 264.164 719.187 262.488 723.649 263.541C721.337 267.596 718.112 271.057 714.229 273.648C710.346 276.239 705.913 277.889 701.281 278.468Z",
    fill: "url(#paint38_linear_2162_5563)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M700.409 273.757C702.343 269.325 703.775 264.69 704.678 259.94C705.392 255.16 704.95 250.064 702.515 245.896C697.77 254.866 696.241 264.493 700.171 273.859",
    fill: "url(#paint39_linear_2162_5563)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M696.921 245.896C694.237 236.995 686.094 230.448 677.294 227.436C676.218 227 675.053 226.825 673.897 226.926C673.313 226.992 672.761 227.228 672.31 227.605C671.859 227.981 671.529 228.482 671.36 229.044C671.043 230.55 672.288 231.909 673.466 232.917C680.345 238.784 688.338 243.198 696.967 245.896",
    fill: "url(#paint40_linear_2162_5563)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M696.83 238.614C696.479 232.883 696.128 227.062 694.259 221.626C692.39 216.19 688.8 211.093 683.568 208.715C682.685 214.513 685.233 220.278 688.313 225.261C691.394 230.245 695.109 234.945 696.966 240.505",
    fill: "url(#paint41_linear_2162_5563)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M696.967 242.567C699.232 236.077 699.424 227.844 703.298 222.181C706.016 218.228 710.365 215.544 712.698 211.365C714.106 215.374 713.912 219.773 712.154 223.642C710.383 227.465 707.952 230.945 704.974 233.925C702.097 236.995 699.64 239.294 696.967 242.544",
    fill: "url(#paint42_linear_2162_5563)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M696.922 433.469C697.091 433.469 697.25 390.228 697.261 336.896C697.273 283.565 697.137 240.302 696.967 240.302C696.797 240.302 696.65 283.542 696.638 336.896C696.627 390.251 696.752 433.469 696.922 433.469Z",
    fill: "url(#paint43_linear_2162_5563)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M659.128 303.928C659.65 304.184 660.197 304.389 660.759 304.54L665.232 306.046C669.004 307.337 674.191 309.194 679.819 311.505C685.448 313.815 690.635 315.831 693.625 318.425C694.82 319.418 695.77 320.674 696.4 322.094C696.83 323.113 696.91 323.736 696.966 323.725C696.993 323.575 696.993 323.422 696.966 323.272C696.902 322.84 696.795 322.415 696.649 322.003C696.078 320.498 695.14 319.158 693.92 318.107C692.115 316.58 690.096 315.325 687.929 314.381C685.528 313.249 682.877 312.116 680.001 310.984C674.338 308.719 669.14 306.873 665.278 305.683C663.375 305.094 661.812 304.653 660.747 304.37C660.22 304.18 659.679 304.032 659.128 303.928Z",
    fill: "url(#paint44_linear_2162_5563)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M646.749 273.508C646.749 273.508 646.885 273.689 647.202 273.995L648.584 275.297L653.771 279.997L671.008 295.355C677.803 301.346 683.557 307.065 687.589 311.38C689.605 313.532 691.201 315.31 692.277 316.556L693.534 317.994C693.676 318.165 693.832 318.324 693.999 318.47C693.999 318.47 693.897 318.266 693.636 317.915C693.376 317.564 692.991 317.043 692.504 316.409C691.473 315.106 689.933 313.272 687.974 311.074C682.765 305.394 677.261 299.991 671.484 294.89C664.689 288.91 658.584 283.565 654.122 279.669L648.81 275.139L647.338 273.916C646.919 273.621 646.76 273.485 646.749 273.508Z",
    fill: "url(#paint45_linear_2162_5563)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M678.279 301.448C678.449 301.368 677.045 298.118 675.652 294.018C674.259 289.918 673.568 286.441 673.387 286.475C673.538 289.124 674.1 291.734 675.052 294.211C675.65 295.982 676.349 297.718 677.147 299.409C677.421 300.141 677.802 300.828 678.279 301.448Z",
    fill: "url(#paint46_linear_2162_5563)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M696.887 327.621C697.267 327.254 697.612 326.852 697.917 326.42L700.579 323.023C702.844 320.135 705.89 316.148 709.356 311.799C712.822 307.45 715.993 303.532 718.292 300.7C719.424 299.353 720.296 298.231 721.01 297.303C721.366 296.909 721.681 296.48 721.95 296.023C721.532 296.358 721.152 296.738 720.817 297.155C720.127 297.903 719.141 299.013 717.941 300.395C715.551 303.147 712.278 307.02 708.88 311.38C705.483 315.741 702.38 319.772 700.239 322.706C699.107 324.189 698.314 325.39 697.736 326.239C697.403 326.667 697.118 327.13 696.887 327.621Z",
    fill: "url(#paint47_linear_2162_5563)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M705.166 316.975C706.84 315.125 708.034 312.893 708.643 310.474C709.295 308.353 709.56 306.132 709.424 303.917H709.153C709.277 304.415 709.368 304.687 709.413 304.675C709.458 304.664 709.47 304.392 709.413 303.871H709.141C708.993 306.031 708.613 308.169 708.009 310.248C707.233 312.559 706.283 314.808 705.166 316.975Z",
    fill: "url(#paint48_linear_2162_5563)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M715.868 303.52C716.616 302.956 717.43 302.484 718.292 302.116C720.473 301.471 722.764 301.29 725.019 301.583C727.312 301.771 729.585 302.15 731.814 302.716C732.731 303.003 733.665 303.23 734.612 303.396C733.785 302.882 732.883 302.5 731.939 302.263C729.729 301.583 727.45 301.15 725.144 300.972C722.803 300.661 720.422 300.917 718.201 301.719C717.234 302.023 716.407 302.661 715.868 303.52Z",
    fill: "url(#paint49_linear_2162_5563)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M718.405 300.27C718.405 300.36 719.81 299.704 722.12 298.911C728.135 296.857 734.573 296.366 740.83 297.484C743.219 297.914 744.669 298.367 744.703 298.254C744.394 298.073 744.063 297.933 743.718 297.835C742.799 297.516 741.861 297.255 740.909 297.053C737.765 296.362 734.537 296.137 731.328 296.385C728.12 296.63 724.965 297.34 721.962 298.492C721.053 298.838 720.168 299.243 719.311 299.704C718.711 299.987 718.383 300.225 718.405 300.27Z",
    fill: "url(#paint50_linear_2162_5563)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M696.967 286.475C698.072 283.4 698.976 280.256 699.674 277.064C700.577 273.925 701.281 270.733 701.78 267.505C700.675 270.58 699.771 273.724 699.073 276.917C698.163 280.053 697.459 283.246 696.967 286.475Z",
    fill: "url(#paint51_linear_2162_5563)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M696.751 286.475C697.612 284.517 698.615 282.624 699.752 280.813C701.024 279.12 702.509 277.597 704.169 276.282C703.537 276.436 702.95 276.739 702.459 277.166C701.206 278.082 700.119 279.204 699.243 280.484C697.892 282.223 697.032 284.292 696.751 286.475Z",
    fill: "url(#paint52_linear_2162_5563)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M696.921 410.421C696.989 410.421 697.114 409.379 697.601 407.545C698.321 404.961 699.292 402.453 700.5 400.059C703.479 393.943 708.915 386.208 715.823 378.45C719.221 374.542 722.619 370.85 725.393 367.317C727.907 364.207 730.179 360.909 732.189 357.452C733.529 355.115 734.666 352.668 735.586 350.136C735.903 349.241 736.141 348.528 736.266 348.041C736.354 347.799 736.415 347.548 736.447 347.293C736.447 347.293 736.073 348.29 735.314 350.045C734.295 352.529 733.091 354.933 731.713 357.237C729.645 360.637 727.337 363.884 724.804 366.954C721.973 370.454 718.655 374.123 715.223 378.042C708.292 385.811 702.867 393.66 699.956 399.866C698.774 402.296 697.863 404.848 697.238 407.477C697.07 408.194 696.941 408.92 696.853 409.651C696.845 409.91 696.868 410.168 696.921 410.421Z",
    fill: "url(#paint53_linear_2162_5563)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M662.774 371.847C663.35 372.219 663.947 372.556 664.564 372.855C666.183 373.765 667.735 374.791 669.207 375.924C671.383 377.613 673.42 379.472 675.3 381.485C677.441 383.75 679.649 386.366 681.892 389.175C686.422 394.837 690.601 399.809 693.115 403.796C694.395 405.778 695.38 407.443 695.935 408.609C696.223 409.234 696.552 409.84 696.921 410.421C696.899 410.243 696.845 410.07 696.762 409.912C696.626 409.583 696.445 409.107 696.151 408.507C695.37 406.806 694.481 405.156 693.489 403.569C691.043 399.481 686.875 394.418 682.379 388.846C680.114 386.026 677.849 383.399 675.719 381.134C673.794 379.123 671.702 377.278 669.468 375.618C667.958 374.507 666.356 373.529 664.677 372.696C664.088 372.39 663.601 372.209 663.284 372.073C662.967 371.937 662.774 371.824 662.774 371.847Z",
    fill: "url(#paint54_linear_2162_5563)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M662.106 384.361C663.353 384.632 664.617 384.814 665.889 384.905C668.927 385.22 671.929 385.812 674.859 386.672C677.753 387.617 680.467 389.041 682.889 390.885C684.746 392.323 685.618 393.501 685.709 393.433C685.566 393.115 685.375 392.821 685.142 392.561C684.545 391.844 683.881 391.184 683.161 390.59C680.764 388.597 678.008 387.082 675.04 386.128C672.074 385.239 669.014 384.696 665.923 384.509C664.658 384.342 663.38 384.293 662.106 384.361Z",
    fill: "url(#paint55_linear_2162_5563)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M684.599 392.063C684.802 391.949 683.092 389.345 681.767 385.845C680.442 382.345 680.238 379.208 680.012 379.242C679.925 379.917 679.948 380.602 680.08 381.269C680.275 382.904 680.654 384.511 681.212 386.06C681.789 387.594 682.525 389.063 683.409 390.443C683.716 391.043 684.118 391.59 684.599 392.063Z",
    fill: "url(#paint56_linear_2162_5563)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M651.71 338.255C651.905 338.376 652.11 338.482 652.322 338.572L654.1 339.377C654.881 339.716 655.821 340.135 656.886 340.702C657.95 341.268 659.207 341.834 660.499 342.604L662.56 343.737C663.285 344.156 663.987 344.643 664.746 345.107C666.263 346.036 667.792 347.169 669.412 348.335C676.38 353.524 682.458 359.813 687.408 366.954C688.54 368.619 689.594 370.182 690.466 371.733C690.907 372.504 691.372 373.228 691.768 373.999L692.901 376.105C693.637 377.43 694.158 378.687 694.667 379.775C695.177 380.862 695.585 381.824 695.891 382.606L696.638 384.418C696.713 384.634 696.816 384.84 696.944 385.03C696.911 384.804 696.851 384.583 696.763 384.373L696.117 382.527C695.791 381.545 695.413 380.581 694.985 379.639C694.498 378.506 693.999 377.249 693.286 375.901C692.935 375.222 692.584 374.508 692.21 373.772C691.836 373.036 691.372 372.288 690.941 371.507C690.081 369.933 689.005 368.347 687.906 366.66C682.973 359.426 676.845 353.084 669.785 347.905C668.143 346.772 666.592 345.64 665.051 344.711C664.293 344.247 663.568 343.76 662.786 343.352L660.691 342.219C659.366 341.46 658.098 340.917 657.01 340.396C656.085 339.937 655.137 339.529 654.168 339.173L652.344 338.471C652.144 338.369 651.931 338.296 651.71 338.255Z",
    fill: "url(#paint57_linear_2162_5563)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M678.743 356.365C678.502 355.471 677.982 354.678 677.26 354.1C675.59 352.666 673.469 351.864 671.269 351.835C669.109 351.827 666.969 352.247 664.972 353.069C664.125 353.33 663.32 353.711 662.582 354.202C663.446 354.038 664.291 353.791 665.108 353.465C667.084 352.791 669.157 352.443 671.246 352.435C673.299 352.492 675.281 353.198 676.909 354.451C677.566 355.043 678.18 355.683 678.743 356.365Z",
    fill: "url(#paint58_linear_2162_5563)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M682.775 360.533C682.956 360.431 681.427 358.2 681.076 354.994C680.959 353.061 681.088 351.12 681.461 349.219C681.103 349.696 680.863 350.25 680.759 350.838C680.033 353.621 680.376 356.575 681.722 359.117C681.96 359.663 682.32 360.147 682.775 360.533Z",
    fill: "url(#paint59_linear_2162_5563)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M726.786 416.639C725.858 433.163 720.875 449.97 713.196 466.958H679.91C672.605 450.14 667.962 433.355 667.146 416.639H726.786Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M672.537 443.356C672.537 443.526 683.511 443.673 697.034 443.673C710.557 443.673 721.531 443.526 721.531 443.356C721.531 443.186 710.568 443.039 697.034 443.039C683.5 443.039 672.537 443.186 672.537 443.356Z",
    fill: "#41525B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M673.285 449.347C673.285 449.517 683.569 449.653 696.253 449.653C708.938 449.653 719.21 449.517 719.21 449.347C719.21 449.177 708.938 449.03 696.253 449.03C683.569 449.03 673.285 449.166 673.285 449.347Z",
    fill: "#41525B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M712.686 427.466C712.263 432.573 712.263 437.705 712.686 442.812C713.094 437.705 713.094 432.573 712.686 427.466Z",
    fill: "#41525B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M694.837 427.466C694.416 432.743 694.416 438.045 694.837 443.322C695.243 438.044 695.243 432.743 694.837 427.466Z",
    fill: "#41525B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M678.075 427.33C677.668 432.725 677.668 438.142 678.075 443.537C678.498 438.143 678.498 432.724 678.075 427.33Z",
    fill: "#41525B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M668.199 427.466C668.199 427.636 681.065 427.772 696.932 427.772C712.799 427.772 725.653 427.636 725.653 427.466C725.653 427.296 712.799 427.149 696.932 427.149C681.065 427.149 668.199 427.296 668.199 427.466Z",
    fill: "#41525B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_5563",
    x1: 354.375,
    y1: 47.1591,
    x2: 571.416,
    y2: 189.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_5563",
    x1: 377.796,
    y1: 84.1129,
    x2: 486.759,
    y2: 154.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2162_5563",
    x1: 369.728,
    y1: 180.351,
    x2: 444.69,
    y2: 280.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2162_5563",
    x1: 347.012,
    y1: 101.298,
    x2: 528.424,
    y2: 270.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2162_5563",
    x1: 335.917,
    y1: 160.215,
    x2: 402.952,
    y2: 316.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2162_5563",
    x1: 359.715,
    y1: 79.4631,
    x2: 555.196,
    y2: 217.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2162_5563",
    x1: 262.242,
    y1: 272.698,
    x2: 271.492,
    y2: 280.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2162_5563",
    x1: 536.318,
    y1: 117.925,
    x2: 545.568,
    y2: 125.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2162_5563",
    x1: 297.072,
    y1: 289.896,
    x2: 299.433,
    y2: 291.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2162_5563",
    x1: 323.563,
    y1: 153.062,
    x2: 325.923,
    y2: 155.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2162_5563",
    x1: 517.216,
    y1: 219.576,
    x2: 519.577,
    y2: 221.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2162_5563",
    x1: 534.465,
    y1: 161.726,
    x2: 536.826,
    y2: 163.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2162_5563",
    x1: 742.822,
    y1: 341.018,
    x2: 748.736,
    y2: 356.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2162_5563",
    x1: 741.184,
    y1: 315.997,
    x2: 764.773,
    y2: 329.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2162_5563",
    x1: 729.132,
    y1: 316.705,
    x2: 744.107,
    y2: 321.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2162_5563",
    x1: 732.591,
    y1: 362.009,
    x2: 753.169,
    y2: 380.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2162_5563",
    x1: 721.118,
    y1: 329.194,
    x2: 734.155,
    y2: 331.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2162_5563",
    x1: 719.088,
    y1: 379.559,
    x2: 734.652,
    y2: 399.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2162_5563",
    x1: 707.926,
    y1: 342.292,
    x2: 723.068,
    y2: 345.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2162_5563",
    x1: 674.978,
    y1: 353.729,
    x2: 689.504,
    y2: 357.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2162_5563",
    x1: 654.102,
    y1: 376.94,
    x2: 660.804,
    y2: 394.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2162_5563",
    x1: 653.92,
    y1: 362.439,
    x2: 669.154,
    y2: 384.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2162_5563",
    x1: 678.816,
    y1: 313.717,
    x2: 691.54,
    y2: 316.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2162_5563",
    x1: 635.953,
    y1: 316.762,
    x2: 657.663,
    y2: 343.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2162_5563",
    x1: 636.578,
    y1: 341.416,
    x2: 647.337,
    y2: 365.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2162_5563",
    x1: 650.275,
    y1: 349.953,
    x2: 662.875,
    y2: 370.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2162_5563",
    x1: 653.823,
    y1: 307.573,
    x2: 661.826,
    y2: 326.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2162_5563",
    x1: 641.725,
    y1: 297.704,
    x2: 647.276,
    y2: 315.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2162_5563",
    x1: 674.561,
    y1: 257.413,
    x2: 682.746,
    y2: 258.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2162_5563",
    x1: 659.194,
    y1: 257.022,
    x2: 682.991,
    y2: 271.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2162_5563",
    x1: 632.066,
    y1: 259.492,
    x2: 652.423,
    y2: 287.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2162_5563",
    x1: 639.475,
    y1: 281.758,
    x2: 645.901,
    y2: 301.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2162_5563",
    x1: 707.317,
    y1: 276.779,
    x2: 716.687,
    y2: 278.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2162_5563",
    x1: 734.127,
    y1: 299.422,
    x2: 744.407,
    y2: 319.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2162_5563",
    x1: 746.394,
    y1: 294.962,
    x2: 755.143,
    y2: 313.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2162_5563",
    x1: 728.647,
    y1: 287.347,
    x2: 734.138,
    y2: 303.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2162_5563",
    x1: 722.99,
    y1: 257.494,
    x2: 738.652,
    y2: 261.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2162_5563",
    x1: 681.286,
    y1: 241.864,
    x2: 705.66,
    y2: 257.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2162_5563",
    x1: 706.946,
    y1: 261.217,
    x2: 721.209,
    y2: 279.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2162_5563",
    x1: 699.718,
    y1: 242.215,
    x2: 710.762,
    y2: 244.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2162_5563",
    x1: 677.807,
    y1: 224.398,
    x2: 695.851,
    y2: 245.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2162_5563",
    x1: 686.828,
    y1: 204.53,
    x2: 706.453,
    y2: 211.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2162_5563",
    x1: 701.186,
    y1: 207.258,
    x2: 723.78,
    y2: 217.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2162_5563",
    x1: 696.796,
    y1: 214.873,
    x2: 697.818,
    y2: 214.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2162_5563",
    x1: 668.715,
    y1: 301.322,
    x2: 685.637,
    y2: 328.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2162_5563",
    x1: 658.714,
    y1: 267.586,
    x2: 701.599,
    y2: 306.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2162_5563",
    x1: 674.629,
    y1: 284.504,
    x2: 682.081,
    y2: 286.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2162_5563",
    x1: 703.234,
    y1: 291.863,
    x2: 731.379,
    y2: 310.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2162_5563",
    x1: 706.253,
    y1: 302.146,
    x2: 712.773,
    y2: 303.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2162_5563",
    x1: 720.615,
    y1: 300.491,
    x2: 721.451,
    y2: 305.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2162_5563",
    x1: 725.064,
    y1: 295.762,
    x2: 726.384,
    y2: 303.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2162_5563",
    x1: 698.186,
    y1: 265.008,
    x2: 705.715,
    y2: 266.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2162_5563",
    x1: 698.63,
    y1: 274.941,
    x2: 707.396,
    y2: 280.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2162_5563",
    x1: 706.879,
    y1: 338.983,
    x2: 757.278,
    y2: 365.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2162_5563",
    x1: 671.421,
    y1: 366.765,
    x2: 707.023,
    y2: 393.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2162_5563",
    x1: 668.083,
    y1: 383.133,
    x2: 674.64,
    y2: 397.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2162_5563",
    x1: 681.139,
    y1: 377.554,
    x2: 688.094,
    y2: 379.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2162_5563",
    x1: 663.165,
    y1: 332.098,
    x2: 707.225,
    y2: 368.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2162_5563",
    x1: 666.675,
    y1: 351.238,
    x2: 669.252,
    y2: 359.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2162_5563",
    x1: 680.995,
    y1: 347.729,
    x2: 684.805,
    y2: 348.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage5);
export default __webpack_public_path__ + "static/media/Image 5.86a16164fc1dddf6c61496a462543e0c.svg";
export { ForwardRef as ReactComponent };